<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="filterDateModal"
      scrollable
      size="lg"
      title="Visualização da rota"
    >
      <!-- {{ imagePath }} -->
      <b-row>
        <b-col class="imageMap">
          <img :src="imagePath" />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            Fechar
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "ViewPath",
  data() {
    return {
      imagePath: "",
    };
  },
  methods: {
    show(image) {
      this.imagePath = image;
      this.$refs.openModal.show();
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>